module.exports = __webpack_public_path__ + "static/img/brees-2015-slide-1.a7edd8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-slide-1.jpg
// module id = uqT2
// module chunks = 1